export default __webpack_public_path__ + "assets/icon-32.png";